/* eslint-disable import/no-cycle */
import {WalletRegistrationSource} from './types';

export const AUTHENTICATED_WALLET_STATE_COOKIE_NAME =
  'authenticatedWalletState';

export const AUTHENTICATED_WALLET_ID_STATE = 'walletId';

export const AUTHENTICATED_WALLET_INFO_STATE = 'walletInfo';

export const AUTHENTICATED_SIGNED_MSG = 'signature';

export const registrationSources: WalletRegistrationSource[] = [
  'walletConnect',
  'metaMask',
  'venly',
  'zilPay',
  'paper',
  'magicLinkEmail',
  'magicLinkSMS',
];

export const PAPERCHAINS = {
  Polygon: 137,
  Amoy: 80002,
  Goerli: 5,
  Ethereum: 1,
};

export const AUTHENTICATION_MESSAGE_TO_SIGN =
  'Welcome to TokenTraxx! Approve this message to securely log in. Signing is a safe, gas-less transaction that does not in any way give Tokentraxx permission to perform any transactions with your wallet';
